var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"list-content"},[_c('div',[_c('img',{staticClass:"image_div",attrs:{"src":_vm.itemChild.bookLogoUrl,"mode":""}}),_vm._v(" "),_c('span',{staticClass:"book_name"},[_vm._v(_vm._s(_vm.itemChild.bookName))])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-46da19fb","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/book_item/four_compontent.vue
// module id = null
// module chunks = 